import React, {useEffect, useState} from "react";
import { onlineProcessesService } from "../../../../services";
import QuadralModal from '@quadral/quadral-component-common/dist/components/modal';
import QuadralButton from '@quadral/quadral-component-common/dist/components/button';
import QuadralDropZone from "@quadral/quadral-component-common/dist/components/dropzone";
import QuadralContainer from "@quadral/quadral-component-common/dist/components/container"
import QuadralAutocomplete from "@quadral/quadral-component-common/dist/components/autocomplete"
import {QuadralLoaderProvider} from '@quadral/quadral-component-common/dist/components/loader/LoaderContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPen } from "@fortawesome/free-solid-svg-icons";

export default function AddDocumentModal ({open, setOpen, persons, updateData, setReceptionBox, getSupportingDocumentCategoryByPerson, selectedUnattachedFile, setAdditionalReceptionRow, getCategory, participation, signatoryPerson, ...props}) {

    const [canConfirm, setCanConfirm] = useState(false);
    const [supportingDocumentCategory, setSupportingDocumentCategory] = useState('');
    const [personId, setPersonId] = useState('');
    const [decision, setDecision] = useState('addToReceptionBox');
    const [selectedDocId, setSelectedDocId] = useState('');
    const [files, setFiles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [existingPJ, setExistingPJ] = useState([]);

    useEffect(()=>{
        if(decision === 'addToSupportingDocument'){
            setCanConfirm(selectedDocId && personId && files.length > 0)
        } else if(decision === 'addToReceptionBox'){
            setCanConfirm(files.length > 0)
        }
    },[selectedDocId, personId, files, decision])

    useEffect(()=>{
        const supportingDocumentbyPerson = getSupportingDocumentCategoryByPerson(personId)
        setExistingPJ(supportingDocumentbyPerson)
    },[personId, getSupportingDocumentCategoryByPerson])

    function closeModal(){
        setOpen(false)
        setFiles([])
        setPersonId('')
        setSelectedDocId('')
    }

    function getBase64(file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsBinaryString(file);
        });
    }

    async function uploadFiles() {
        setIsLoading(true);
        if(decision === 'addToSupportingDocument'){
            props.showLoader();
            setFiles([]);
            const formData = new FormData();

            files.forEach((file, index) => {
                const fieldName = index === 0 ? "file" : `file${index + 1}`;
                formData.append(fieldName, file);
            });

            await onlineProcessesService.uploadSupportingDocumentFile({
                participationId: participation?.id,
                personRecordId: personId,
                supportingDocumentId: selectedDocId
            }, formData)
                .then(response => {
                    updateData();
                    closeModal();
                    setIsLoading(false);
                    props.setUpdatedDocumentId(selectedDocId);
                    props.quadralToast.success('Fichier(s) ajouté(s) avec succès.'); 
                })
                .catch(error => {
                    closeModal();
                    props.hideLoader(false);
                    setIsLoading(false);
                    props.quadralToast.error(error.response?.data?.message || 'Erreur lors du téléversement.');
                });
        } else if(decision === 'addToReceptionBox'){
            setFiles([]);
            props.showLoader();

            const promises = [];
            if (files) {
                promises.push(getBase64(files[0]));
            }

            const formData = new FormData();
            files.forEach((file, index) => {
                const fieldName = index === 0 ? "file" : `file${index + 1}`;
                formData.append(fieldName, file);
            });

            Promise.all(promises)
                .then(data => {
                    props.showLoader();
                    return onlineProcessesService.uploadDocumentToReceptionBox(participation?.id, formData);
                }).then(result => {
                    // TODO Ajouter un loader pendant qu'il cherche le document
                    // Il faut attendre que le document soit bien dans la GED alors :
                    const pollForDocument = async (maxAttempts = 10, interval = 500) => {
                        for (let attempt = 0; attempt < maxAttempts; attempt++) {
                            try {
                                const receptionData = await onlineProcessesService.getSplitFiles(participation?.id);
                                const newDocumentExists = receptionData?.some(doc =>
                                    doc.originalDocumentName === files[0].name ||
                                    doc.name === files[0].name
                                );

                                if (newDocumentExists) {
                                    console.log(`Document trouvé après ${attempt + 1} tentatives`);
                                    return true;
                                }

                                await new Promise(resolve => setTimeout(resolve, interval));
                            } catch (error) {
                                console.warn(`Erreur lors de la vérification (tentative ${attempt + 1}):`, error);
                            }
                        }

                        console.warn('Document non trouvé après toutes les tentatives, rechargement forcé');
                        return false;
                    };

                    pollForDocument()
                        .then(() => {
                        updateData();
                        })
                        .finally(() => {
                            closeModal();
                            props.hideLoader(false);
                            setIsLoading(false);
                            props.quadralToast.success('Fichier(s) ajouté(s) avec succès.');
                        });
                }).catch(error => {
                    closeModal();
                    props.hideLoader(false);
                    setIsLoading(false);
                    props.quadralToast.error(error.response?.data?.message || 'Erreur lors du téléversement.');
                });
        }
    }

    return (
    <>
        <QuadralLoaderProvider/>
        {open && (  
            <QuadralModal
                size='XL'
                title='Charger un fichier'
                icon={<FontAwesomeIcon icon={faUserPen}/>}
                open={open}
                setOpen={setOpen}
                action={<>
                    <QuadralButton 
                        color='error'
                        onClick={() => setOpen(false)}
                        disabled={isLoading}
                    >
                        Annuler
                    </QuadralButton>
                    <QuadralButton
                        color='success'
                        onClick={() => uploadFiles()}
                        disabled={!canConfirm || isLoading}
                    >
                        Confirmer
                    </QuadralButton>
                </>}
            >
                <QuadralContainer orientation='row'>
                    <QuadralContainer orientation='column'>
                        <div>
                            <label>
                                <input
                                    type="radio"
                                    name="decision"
                                    value="addToReceptionBox"
                                    checked={decision === 'addToReceptionBox'}
                                    onChange={(e) => setDecision(e.target.value)}
                                />
                                <span className="ml-2">Ajouter à la boîte de tri</span>
                            </label>
                        </div>
                        <div>
                            <label>
                                <input
                                    type="radio"
                                    name="decision"
                                    value="addToSupportingDocument"
                                    checked={decision === 'addToSupportingDocument'}
                                    onChange={(e) => setDecision(e.target.value)}
                                />
                                <span className="ml-2">Ajouter à une pièce justificative</span>
                            </label>
                        </div>
                        <div className="form-group mt-3">
                            <QuadralAutocomplete
                                label="Personne"
                                options={persons}
                                value={persons.find((p) => p.id === personId) ?? null}
                                getOptionLabel={(p) => `${p.firstname} ${p.lastname}`}
                                onChange={(event, person) => {
                                    setPersonId(person?.id ?? null);
                                    setSupportingDocumentCategory(null);
                                    setSelectedDocId(null);
                                }}
                                disabled={decision === 'addToReceptionBox'}
                                placeholder={persons.length === 0 ? 'Pas de personnes disponibles' : 'Sélectionner une personne'}
                            />
                        </div>
                        <div className="form-group mt-3">
                            <QuadralAutocomplete
                                label="Pièce existante"
                                options={existingPJ}
                                value={supportingDocumentCategory}
                                getOptionLabel={(p) => getCategory(p)}
                                onChange={(event, item) => {
                                    setSupportingDocumentCategory(item)
                                    const doc = existingPJ.find(d => d?.category === item?.category)
                                    setSelectedDocId(doc?.id);
                                }}
                                disabled={personId === '' || personId === null || decision === 'addToReceptionBox' || existingPJ.length === 0}
                                placeholder={personId ? (existingPJ.length === 0 ? 'Pas de pièces justificatives existantes' : 'Sélectionner une pièce justificative') : 'Sélectionner une personne d\'abord'}
                            />
                        </div>
                    </QuadralContainer>
                    <QuadralDropZone
                        id={selectedDocId}
                        files={files}
                        onFilesChange={setFiles}
                        uploadFiles={uploadFiles}
                        accept={{
                                'application/pdf': ['.pdf'],
                                'image/*': []
                            }}
                        maxFiles={5}
                        maxTotalSize={20 * 1024 * 1024}
                    />
                </QuadralContainer>
            </QuadralModal>
        )}
    </>
  );
}